import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Flex } from 'reflexbox'
import { branch, compose, renderComponent } from 'recompose'

import ProgressBar from 'components/fulcrum/progressBar/FulcrumCircularProgressBar'
import { loading } from './index'

const Progress = () => <Flex justify='center'><ProgressBar/></Flex>

export default loading(Progress)
